// extracted by mini-css-extract-plugin
module.exports = {"noResultsImage":"all_noResultsImage__3ztxO"};